import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import kirbyWebP from '@/assets/kirby.webp';
import kirbyJPG from '@/assets/kirby.jpg';
import { BOOKING_URL } from '@/constants/urls';

interface TeamMember {
  name: string;
  title: string;
  description: string;
  schedule: string;
  bookingUrl?: string;
  imageWebP: string;
  imageJPG: string;
  alt: string;
}

const TeamSection: React.FC = () => {
  const teamMembers: TeamMember[] = [
    {
      name: "Dr. Kirby Quin",
      title: "Acupuncturist",
      description:
      "Dr. Kirby Quin brings over seven years of clinical experience to Women and the Way, with a special focus on preconception, pregnancy, and postpartum care. Having previously practiced at DQ Chinese Medicine, she is known for her deeply intuitive and nurturing approach. Based in Currimundi on the Sunshine Coast, Kirby offers gentle acupuncture and herbal medicine tailored to support hormonal balance, fertility, birth preparation, and recovery after childbirth.",
      schedule: "By appointment only.",
      bookingUrl: BOOKING_URL,
      imageWebP: kirbyWebP,
      imageJPG: kirbyJPG,
      alt: "Dr. Kirby Quin providing acupuncture for fertility and postpartum care on the Sunshine Coast"
    }
  ];

  return (
    <section id="team" className="section-padding bg-sage-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="mb-4 bg-gradient-to-r from-sage-600 to-amber-500 bg-clip-text text-transparent">
            Our Team
          </h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            Our experienced practitioners are dedicated to providing compassionate and specialised care for women's health.
          </p>
        </div>

        <div className="grid md:grid-cols-1 gap-8 max-w-lg mx-auto">
          {teamMembers.map((member, index) => (
            <Card
              key={index}
              className="overflow-hidden rounded-2xl shadow-lg border-4 border-amber-200/30 card-hover"
            >
              <div className="h-64 overflow-hidden">
                <picture>
                  <source srcSet={member.imageWebP} type="image/webp" />
                  <img
                    src={member.imageJPG}
                    alt={member.alt}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                </picture>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-serif font-medium mb-1 text-sage-800">{member.name}</h3>
                <p className="text-lavender-600 font-medium mb-3">{member.title}</p>
                <p className="text-gray-600 mb-4 text-sm">{member.description}</p>
                <div className="pt-4 border-t border-sage-100">
                  <h4 className="text-sm font-medium text-sage-700 mb-2">Schedule</h4>
                  <p className="text-gray-600 text-sm mb-2">{member.schedule}</p>
                  {member.bookingUrl ? (
                    <a
                      href={member.bookingUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex text-sm font-medium text-amber-800 underline underline-offset-2 hover:text-amber-900"
                    >
                      Book an appointment online
                    </a>
                  ) : null}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
